"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.warning.name.required': 'Podaj przynajmniej nazwę awatara, aby kontynuować.',
};
